import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQueryClient } from '@tanstack/react-query';

import type { BookingcomRoomsList } from 'app/typings/core/extranet/inventory/autoInventory';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '..';

export const AUTO_INVENTORY_ROOMS_STALE_TIME = 5 * MILLISECONDS_IN_MINUTE;

export const fetchAutoInventoryRooms = (
  hotelId: number
): Promise<BookingcomRoomsList[]> =>
  apiRequest({
    path: ENDPOINTS.getAutoInventoryRooms,
    params: { hotelId: hotelId.toString() },
  });

export function useAutoInventoryRooms() {
  const queryClient = useQueryClient();

  const getAutoInventoryRooms = (hotelId: number) => {
    return queryClient.fetchQuery({
      queryKey: [CORE_QUERY_KEYS.autoInventoryRooms, { hotelId }],
      queryFn: () => fetchAutoInventoryRooms(hotelId),
      staleTime: AUTO_INVENTORY_ROOMS_STALE_TIME,
    });
  };

  return {
    getAutoInventoryRooms,
  };
}
